// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3ZZZH","label":"LabeledBox_label__2qYXT"};